<template>
    <section class="row flex-column">
        <div class="block block-rounded block-bordered">
            <div class="block-header">
                <h3 class="block-title">Messaging <small>View</small></h3>
                <div class="block-options">
                    <button :disabled="message.isBlocked" @click="pauseControl('pause')" v-if="message" type="button"
                            class="btn btn-sm btn-outline-primary">
                        <i class="si" :class="message.isPaused ? 'si-control-play' : 'si-control-pause'"/>
                        {{ message.isPaused ? 'Continue' : 'Pause' }}
                    </button>
                    <button @click="pauseControl('purge')" :disabled="message.isBlocked" v-if="message" type="button"
                            class="ml-1 btn btn-sm btn-outline-danger">
                        <i class="si si-trash"/>
                        Stop
                    </button>
                    <button @click="downloadReport()" :disabled="message.isBlocked" v-if="message" type="button"
                            class="ml-1 btn btn-sm btn-outline-success">
                        <i class="si si-cloud-download"/>
                        Download Delivery Report
                    </button>
                </div>
            </div>
            <div class="block-content border-top">
                <div class="row">
                    <div class="col-md-6 col-xl-3 mb-2">
                        <a class="block block-rounded block-bordered" href="javascript:void(0)">
                            <div
                                    class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div>
                                    <i class="fa fa-2x fa-phone text-primary"/>
                                </div>
                                <div class="ml-3 text-right">
                                    <p class="font-w300 mb-0">
                                        <span v-if="message" class="font-size-h4">{{message.totalSent || 0}}</span>
                                    </p>
                                    <p class="text-muted mb-0">
                                        Total Recipients
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-2">
                        <a class="block block-rounded block-bordered" href="javascript:void(0)">
                            <div
                                    class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div>
                                    <i class="fa fa-2x fa-envelope-open text-success"/>
                                </div>
                                <div class="ml-3 text-right">
                                    <p class="font-w300 mb-0">
                                        <span class="font-size-h4" v-if="message.realtimeStats">{{message.realtimeStats.DeliveredToTerminal || 0}}</span>
                                    </p>
                                    <p class="text-muted mb-0">
                                        Delivered
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-2">
                        <a class="block block-rounded block-bordered" href="javascript:void(0)">
                            <div
                                    class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div class="mr-3">
                                    <p class="font-size-h3 font-w300 mb-0">
                                        0
                                    </p>
                                    <p class="text-muted mb-0">
                                        Queued
                                    </p>
                                </div>
                                <div>
                                    <i class="fa fa-2x fa-clock text-warning"/>
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-2">
                        <a class="block block-rounded block-bordered" href="javascript:void(0)">
                            <div
                                    class="block-content block-content-full d-flex align-items-center justify-content-between">
                                <div class="mr-3">
                                    <p class="font-w300 mb-0">
                                        <span class="font-size-h4" v-if="message.realtimeStats"> {{message.realtimeStats.SENT || 0}}</span>
                                    </p>
                                    <p class="text-muted mb-0">
                                        Sent
                                    </p>
                                </div>
                                <div>
                                    <i class="fa fa-2x fa-check-double text-info"/>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="row border-top">

                </div>
            </div>
            <div class="block-content-full mr-1  ml-1">
                <div class="block block-rounded block-bordered">
                    <div class="block-content-full">
                        <div class="progress">
                            <div class="progress-bar"
                                 role="progressbar"
                                 :style="{width: progress}"
                                 aria-valuenow="75"
                                 aria-valuemin="0"
                                 aria-valuemax="100">{{progress}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block block-bordered pb-0">
                <div class="block-content block-content-sm block-content-full bg-body-light">
                    <div class="row border-bottom">
                        <div class="col-md-5 border-right mb-2">
                            <strong>MessageId:</strong> <small>{{message.messageId}}</small>
                        </div>
                        <div class="col-md-2 border-right mb-2">
                            <strong>Sender:</strong> {{message.senderName}}
                        </div>
                        <div class="col-md-5 mb-2">
                            <strong>Created At:</strong> <small>{{message.createdAt}}</small>
                        </div>
                    </div>
                </div>
                <div class="block-content">
                    <p>{{message.message}}</p>
                </div>
            </div>
            <div class="block block-bordered">
                <div class="block-header border-bottom">
                    <div class="block-title">
                        Sent and Delivery Stats
                    </div>
                </div>
                <div class="block-content">
                    <div class="row border-bottom">
                        <div class="col-md-4 mb-2" v-for="(stat, idx) of message.realtimeStats" :key="idx">
                            <strong>{{idx.toUpperCase()}}:</strong> <small>{{stat}}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {APP_CONFIG} from "../../config";
    import {Echo, axios} from "../../bootstrap";

    export default {
        name: "MessageView",
        data() {
            return {
                delivery: {},
                message: {},
                query: '',
                data: {},
                loading: true,
                progress: "0%",
                statsHandler: null
            }
        },
        mounted() {
            this.getMessage();
            this.statsHandler = setInterval(() => this.getMessage(),5000)
        },
        beforeDestroy() {
            clearInterval(this.statsHandler)
        },
        methods: {
            subscribeToChannels(messageId) {
                Echo.private('SMS_Outbox_Message.' + messageId).listen('.message.sent', res => {
                    this.updateProgress(res.message)
                }).listen('.message.delivered', res => {
                    this.updateProgress(res.message)
                })
            },

            downloadReport() {
                axios({
                    url: `${APP_CONFIG.URL}web/projects/${this.$route.params.project}/sms/${this.message.id}/delivery-report`,
                    method: 'GET',
                    responseType: 'blob',
                }).then((response) => {
                    let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    let fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'delivery-report-' + this.message.messageId + '.csv');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                });
            },

            pauseControl(action) {
                if (this.message.isPaused) {
                    action = 'unpause'
                }
                let url = APP_CONFIG.URL + `web/projects/${this.$route.params.project}/sms/outbox/${this.$route.params.message}`;
                axios.post(url, {
                    action
                }).then(res => {
                    this.updateProgress(res.data.data)
                });
            },

            updateProgress(message) {
                this.message = message;
                let stats = message.realtimeStats,
                    total = this.message.totalSent || 1,
                    sent = stats['SENT'] || 0,
                    progress = Math.round((sent / total) * 100);
                this.progress = progress + '%';
            },

            getMessage() {
                axios.get(APP_CONFIG.URL + `web/projects/${this.$route.params.project}/sms/outbox/${this.$route.params.message}`)
                    .then(res => {
                        this.subscribeToChannels(res.data.data.id);
                        this.updateProgress(res.data.data);
                    });
            }
        }
    }

</script>

<style scoped>
    .col-md-6 .block {
        margin-bottom: 0;
    }
</style>
